// extracted by mini-css-extract-plugin
export default {"planComparatorContainer":"PlanComparator_planComparatorContainer__HfxZm"};